/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useTranslation } from "next-i18next";

import Channels, { ChannelsProps } from "./Channels";

import styles from "./ChannelsSection.module.scss";

const ChannelsSection = ({ channels }: ChannelsProps) => {
  const { t } = useTranslation("translations");

  return (
    <>
      <h2 className={styles.title}>
        {t("web_search_explore_categories_text")}
      </h2>
      <Channels channels={channels} />
    </>
  );
};

export default ChannelsSection;
